module.exports = __webpack_public_path__ + "img/bubble-chat.48d89209.png";